'use strict';

class MarketplacePlacesManager {

    constructor(containerSelector, limits) {
        this.container = $(containerSelector);
        this.limits = limits;
        this.places = [];
        this.currentTariff = 'box';

        this._initExistingPlaces();
    }


    _initExistingPlaces() {
        const self = this;
        this.container.find('.place').each(function(index) {
            try {
                const place = new MarketplacePlace($(this), self.limits, index);
                self.places.push(place);
                place.updateIndicators(self.currentTariff);
            } catch (error) {
                console.error(`Ошибка при инициализации места ${index}:`, error);
            }
        });
    }


    addPlace() {
        const index = this.places.length;
        const limits = this.limits[this.currentTariff];

        const newPlaceHtml = `
            <div class="place mt-3">
                <div class="card border-0">
                    <div class="card-body pb-0">
                        <h5 class="card-title">Груз ${index + 1}</h5>
                        <div class="row">
                            <div class="col-12 col-lg-4 pt-3">
                                <p class="bold">Габариты (ДхШхВ), см</p>
                                <div class="input-group">
                                    <input type="number" class="form-control length" placeholder="Д" 
                                        name="places[${index}][length]" step="1" min="1" 
                                        max="${limits.maxL}" value="10" required 
                                        data-toggle="tooltip" title="Макс. длина: ${limits.maxL} см">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">×</span>
                                    </div>
                                    <input type="number" class="form-control width" placeholder="Ш" 
                                        name="places[${index}][width]" step="1" min="1" 
                                        max="${limits.maxW}" value="10" required 
                                        data-toggle="tooltip" title="Макс. ширина: ${limits.maxW} см">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">×</span>
                                    </div>
                                    <input type="number" class="form-control height" placeholder="В" 
                                        name="places[${index}][height]" step="1" min="1" 
                                        max="${limits.maxH}" value="10" required 
                                        data-toggle="tooltip" title="Макс. высота: ${limits.maxH} см">
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-3 px-2 pt-3">
                                <p class="bold">V места(м³)</p>
                                <input type="number" class="form-control volume vol" name="places[${index}][volume]" readonly>
                            </div>
                            <div class="col-12 col-md-6 col-lg-3 px-2 pt-3">
                                <p class="bold">Вес места(кг)</p>
                                <input type="number" class="form-control weight" name="places[${index}][weight]" 
                                    step="0.1" value="1" min="1" required>
                            </div>
                            <div class="col-12 col-lg-2 pt-3 px-2">
                                <p class="bold d-none">Кол-во мест</p>
                                <p class="bold">Кол-во мест</p>
                                <input type="number" class="form-control count_place" 
                                    name="places[${index}][count_place]" value="1" min="1" required>
                            </div>
                           
                        </div>
                        <div class="progress-indicators mb-2">
                            <div class="box-indicators">
                                <div class="d-flex justify-content-between">
                                    <small>V места (max ${this.limits.box.maxVolume} м³)</small>
                                    <small class="volume-value"></small>
                                </div>
                                <div class="progress" style="height: 3px;">
                                    <div class="progress-bar volume-progress" role="progressbar"></div>
                                </div>
                                <div class="d-flex justify-content-between mt-1">
                                    <small>Вес места (max ${this.limits.box.maxWeight} кг)</small>
                                    <small class="weight-value"></small>
                                </div>
                                <div class="progress" style="height: 3px;">
                                    <div class="progress-bar weight-progress" role="progressbar"></div>
                                </div>
                            </div>
                            <div class="big-indicators" style="display: none;">
                                <div class="d-flex justify-content-between">
                                    <small>Соответствие тарифу "Паллет"</small>
                                    <small class="params-value"></small>
                                </div>
                                <div class="progress" style="height: 4px;">
                                    <div class="progress-bar params-progress" role="progressbar"></div>
                                </div>
                            </div>
                            <div class="place-message mt-1 d-none"></div>
                        </div>
                                             
                        <div class="additional-services mt-031" data-place-index="${index}">
                         <div class="row">
                          <div class="col-8 col-md-10">
                            <button class="btn btn-primary btn-sm" type="button" data-toggle="collapse" 
                                    data-target="#services-collapse-${index}" aria-expanded="false" aria-controls="services-collapse-${index}">
                                <i class="fas fa-plus"></i> услуги
                            </button>
                            </div>
                            <div class="col-4 col-md-2">
                                <button type="button" class="btn btn-danger btn-sm remove-place">
                                    <i class="fas fa-trash"></i>
                                </button>
                            </div>
                            </div>
                            <div class="collapse mt-2" id="services-collapse-${index}">
                                <div class="card border-0 card-body">
                                    <div class="text-center">
                                        <div class="spinner-border text-primary" role="status">
                                            <span class="sr-only">Загрузка...</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;

        this.container.append(newPlaceHtml);
        const newPlaceElement = this.container.find('.place').last();

        this.loadServicesCheckboxes(index);

        const place = new MarketplacePlace(newPlaceElement, this.limits, index);
        this.places.push(place);
        place.updateIndicators(this.currentTariff);
    }

    loadServicesCheckboxes(index) {
        $.ajax({
            url: '/marketplace-calculation/get-services-checkboxes',
            type: 'GET',
            data: { placeIndex: index },
            success: (html) => {
                const servicesContainer = this.container.find(`.additional-services[data-place-index="${index}"] .card-body`);
                servicesContainer.html(html);
            },
            error: () => {
                const servicesContainer = this.container.find(`.additional-services[data-place-index="${index}"] .card-body`);
                servicesContainer.html('<div class="alert alert-danger">Ошибка загрузки услуг</div>');
            }
        });
    }

    removePlace(index) {
        if (index >= 0 && index < this.places.length) {
            this.places[index].element.remove();
            this.places.splice(index, 1);
            this.renumberPlaces();
        }
    }

    renumberPlaces() {
        for (let i = 0; i < this.places.length; i++) {
            const place = this.places[i];
            place.index = i;
            place.element.find('.card-title').text(`Место ${i + 1}`);
            place.element.find('input').each(function() {
                const name = $(this).attr('name');
                if (name) {
                    $(this).attr('name', name.replace(/places\[\d+\]/, `places[${i}]`));
                }
            });

            place.initServices();
        }
    }

    setTariff(tariffType) {
        if (this.currentTariff !== tariffType) {
            this.currentTariff = tariffType;

            for (const place of this.places) {
                place.updateDimensionLimits(tariffType);
                place.updateIndicators(tariffType);
            }
        }
    }

    validatePlaces() {
        let hasInvalidPlaces = false;
        let errorMessage = '';

        for (const place of this.places) {
            if (this.currentTariff === 'box') {
                if (!place.isValidForBoxTariff()) {
                    hasInvalidPlaces = true;
                    errorMessage = 'Некоторые места не соответствуют параметрам тарифа "Короб", попробуйте изменить параметры или выбрать тариф "Паллет"';
                    break;
                }
            } else {
                if (!place.isValidForBigTariff()) {
                    hasInvalidPlaces = true;
                    errorMessage = 'Некоторые места не соответствуют параметрам тарифа "Паллет", попробуйте выбрать тариф "Короб"';
                    break;
                }
            }
        }

        return {
            isValid: !hasInvalidPlaces,
            message: errorMessage
        };
    }

    getPlacesData() {
        return this.places.map(place => place.getData());
    }
}